import { render, staticRenderFns } from "./DoctorsModule.vue?vue&type=template&id=47df763c&scoped=true"
import script from "./DoctorsModule.vue?vue&type=script&lang=js"
export * from "./DoctorsModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47df763c",
  null
  
)

export default component.exports